import React, { useEffect } from "react";
import Title from "../Title";
import { BsCollectionFill } from "react-icons/bs";
import Movie from "../Movies";
import { Movies } from "../screen components/Data/MovieData";
import AOS from "aos";
import "aos/dist/aos.css";

const PopularMovies = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="my-16">
      <Title title="Popular Movies" Icon={BsCollectionFill} />
      <div
        className="grid sm:mt-12 mt-6 xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-10"
        data-aos="zoom-in"
      >
        {Movies.slice(0, 8).map((movie, index) => (
          <Movie key={index} movie={movie} />
        ))}
      </div>
    </div>
  );
};

export default PopularMovies;
